import { createFileRoute } from "@tanstack/react-router";

import { BlogCategoryPage, categoryHead } from "../components/blog/BlogCategoryPage";

export const Route = createFileRoute("/blog/social-media")({
  head: () => categoryHead("socialMedia", 1),
  component: CategoryRoute,
});

function CategoryRoute() {
  return <BlogCategoryPage categoryKey="socialMedia" page={1} />;
}
